import * as React from 'react';
import { useFieldArray, useForm } from 'react-hook-form';

import sortBy from 'lodash/sortBy';

import { SerializedData } from './types';

export function useSerialNumberForm({
  editableSerialFields,
}: {
  editableSerialFields: SerializedData[];
}) {
  const {
    control,
    watch,
    register,
    setValue,
    formState,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    reset,
  } = useForm({
    mode: 'all',
  });

  const { isDirty, dirtyFields, errors } = formState;

  const { fields, update, remove } = useFieldArray({
    control,
    name: 'editableFields',
  });

  React.useEffect(() => {
    const serialData = sortBy(editableSerialFields, (o: SerializedData) =>
      Boolean(o?.checkedIn)
    ).map((field, index) => ({
      ...field,
      name: `serial[${index}]`,
    }));

    setValue('editableFields', serialData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editableSerialFields]);

  return {
    control,
    getValues,
    formState,
    setValue,
    register,
    handleSubmit,
    watch,
    fields,
    update,
    remove,
    isDirty,
    dirtyFields,
    errors,
    setError,
    clearErrors,
    reset,
  };
}
